import { useQuery, useMutation } from '@tanstack/react-query'
import { generatePath } from 'react-router'
import doRequest from '../doRequest'
import { LOGIN, GETLOGIN, LOGOUT, FORGOT_PASSWORD, RESET_PASSWORD, SIGNUP_INITIATE, SIGNUP_VALIDATE, SIGNUP_COMPLETE } from '../../services/URLs'
import useRequest from '../useRequest'

const QUERIES = {
  LOGIN: 'LOGIN',
  SIGNUP_VALIDATE: 'SIGNUP_VALIDATE',
}

const MUTATIONS = {
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  FORGOT_PASSWORD: 'FORGOT_PASSWORD',
  RESET_PASSWORD: 'RESET_PASSWORD',
  SIGNUP_INITIATE: 'SIGNUP_INITIATE',
  SIGNUP_COMPLETE: 'SIGNUP_COMPLETE',
}

export const useQueryMethodByURL = (publicKey: string) => {
  return useQuery({
    queryKey: [QUERIES.LOGIN],
    queryFn: async () => {
      return await doRequest({
        method: 'post',
        url: generatePath(GETLOGIN, { accountId: publicKey }),
        config: {
          headers: {}
        },
        completeResponse: false,
      })
    },
  })
}

export const useGetUserLogin = () => {
  const request = useRequest();

  return useMutation({
    mutationKey: [MUTATIONS.LOGIN],
    mutationFn: async (payload: { email: string; password: string }) => {
      return await request({
        method: 'post',
        url: LOGIN,
        payload,
        config: { headers: {} },
        completeResponse: false,
      });
    },
  });
};

export const useUserLogout = () => {
  const request = useRequest();

  return useMutation({
    mutationKey: [MUTATIONS.LOGOUT],
    mutationFn: async (payload: {}) => {
      return await request({
        method: 'post',
        url: LOGOUT,
        payload,
        config: { headers: {} },
        completeResponse: false,
      });
    },
  });
};

export const useUserForgotPassword = () => {
  const request = useRequest();

  return useMutation({
    mutationKey: [MUTATIONS.FORGOT_PASSWORD],
    mutationFn: async (payload: {email: string;}) => {
      return await request({
        method: 'post',
        url: FORGOT_PASSWORD,
        payload,
        config: { headers: {} },
        completeResponse: true,
      });
    },
  });
};

export const useUserResetPassword = () => {
  const request = useRequest();

  return useMutation({
    mutationKey: [MUTATIONS.RESET_PASSWORD],
    mutationFn: async (payload: {token: string; password: string;}) => {
      return await request({
        method: 'post',
        url: RESET_PASSWORD,
        payload,
        config: { headers: {} },
        completeResponse: true,
      });
    },
  });
};

export const useUserSignUpInitiate = () => {
  const request = useRequest();

  return useMutation({
    mutationKey: [MUTATIONS.SIGNUP_INITIATE],
    mutationFn: async (payload: {email: string;}) => {
      return await request({
        method: 'post',
        url: SIGNUP_INITIATE,
        payload,
        config: { headers: {} },
        completeResponse: true,
      });
    },
  });
};

export const useUserSignUpValidate = (token: string | undefined) => {
  const request = useRequest();

  return useQuery({
    queryKey: [QUERIES.SIGNUP_VALIDATE, token],
    queryFn: async () => {
      if (!token) {
        return {}
      }
      return await request({
        method: 'get',
        url: generatePath(SIGNUP_VALIDATE, { token: token }),
        config: { headers: {} },
        completeResponse: false,
      });
    },
    enabled: !!token,
  });
};

export const useUserSignUpComplete = () => {
  const request = useRequest();

  return useMutation({
    mutationKey: [MUTATIONS.SIGNUP_COMPLETE],
    mutationFn: async (payload: {email: string; tempPassword: string; firstName: string; lastName: string; phone: string; token: string}) => {
      return await request({
        method: 'post',
        url: SIGNUP_COMPLETE,
        payload,
        config: { headers: {} },
        completeResponse: true,
      });
    },
  });
};
